import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Ticket, Trophy, Users, Sparkles, Gift, Star, ArrowRight, Play, MessageCircle } from 'lucide-react'
import Header from './components/Header'
import Hero from './components/Hero'
import Features from './components/Features'
import HowItWorks from './components/HowItWorks'
import ActiveRaffles from './components/ActiveRaffles'
import Testimonials from './components/Testimonials'
import Footer from './components/Footer'
import RafflePage from './components/RafflePage'
import Login from './components/Login'
import MyAccount from './components/MyAccount'
import AdminPage from './components/AdminPage'
import ResultadoTransaccion from './components/ResultadoTransaccion'

// Componente de la página principal
const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900">
      <Header />
      <Hero />
      <HowItWorks />
      <Features />
      <ActiveRaffles />
      <Testimonials />
      <Footer />
      
      {/* Botón flotante de WhatsApp */}
      <motion.a
        href="https://wa.me/573001234567?text=Hola,%20necesito%20información%20sobre%20los%20sorteos"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 group"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
      >
        <MessageCircle className="w-6 h-6" />
        <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          ¿Necesitas ayuda? ¡Escríbenos!
        </div>
      </motion.a>
    </div>
  )
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/membresia/:id" element={<RafflePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/mi-cuenta" element={<MyAccount />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/resultado-transaccion" element={<ResultadoTransaccion />} />
      </Routes>
    </Router>
  )
}

export default App